import "./htmx.js";

import _hyperscript from "hyperscript.org";
_hyperscript.browserInit();

import "./style.css";

import "github-markdown-css";
import "./view-markdown.css";